/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgMarkAllAsReadAlt = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="m14.207 12.207-1.414-1.414L9 14.586l-1.793-1.793-1.414 1.414L9 17.414z" />
        <path d="M6 2v4H2v16h16v-4h4V2zm2 4V4h12v12h-2V6zM4 20V8h12v12z" />
      </g>
    </g>
  </Icon>
);
export { SvgMarkAllAsReadAlt as MarkAllAsReadAlt };
